module.exports = __webpack_public_path__ + "img/logo1.1cc8cc9c.png";